module.exports = __webpack_public_path__ + "static/img/system-2.f58989b8.png";